import { render, staticRenderFns } from "./BillingDataTable.vue?vue&type=template&id=0505ca2c&scoped=true"
import script from "./BillingDataTable.vue?vue&type=script&lang=js"
export * from "./BillingDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0505ca2c",
  null
  
)

export default component.exports